import { PickingRequirementDetails } from '@warebee/shared/engine-model';
import { MappingSchema } from '@warebee/shared/import-converter';
import {
  Field,
  GraphQLJSON,
  GraphQLLocalDateTime,
  ID,
} from '@warebee/shared/util-backend-only-types';
import { OrderLineId } from './picklist-line.model';

export class PickingRequirementAthena {
  @Field(() => ID)
  unitOfWork: string;

  @Field(() => ID)
  itemId: string;

  @Field(() => ID, { nullable: true })
  pickingWaveId?: string;

  @Field(() => GraphQLLocalDateTime, { nullable: true })
  pickByDate?: string;

  @Field()
  customer?: string;

  @Field()
  consignee: string;

  @Field()
  sku: string;

  @Field()
  quantity: number;

  @Field(() => ID)
  orderLineRuleId: string;

  @Field(() => GraphQLJSON)
  orderLines: OrderLineId[];

  @Field(() => GraphQLLocalDateTime, { nullable: true })
  dateFrom?: string;

  @Field(() => GraphQLLocalDateTime, { nullable: true })
  dateTo?: string;

  @Field(() => ID, { nullable: true })
  pickingPriority?: string;

  @Field(() => PickingRequirementDetails, { nullable: true })
  details?: PickingRequirementDetails;
}

export const PICKING_REQUIREMENT_SCHEMA: MappingSchema<PickingRequirementAthena> =
  {
    fields: [
      { name: 'unitOfWork', type: 'string' },
      { name: 'itemId', type: 'string' },
      { name: 'pickingWaveId', type: 'string', optional: true },
      { name: 'pickByDate', type: 'localDateTime', optional: true },
      { name: 'customer', type: 'string', optional: true },
      { name: 'consignee', type: 'string' },
      { name: 'sku', type: 'string' },
      { name: 'quantity', type: 'integer' },
      { name: 'orderLineRuleId', type: 'string' },
      { name: 'orderLines', type: 'string' },
      { name: 'dateFrom', type: 'localDateTime', optional: true },
      { name: 'dateTo', type: 'localDateTime', optional: true },
      { name: 'pickingPriority', type: 'string', optional: true },
      { name: 'details', type: 'string', optional: true },
    ],
  };
